
import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              {t('brand')}
            </h3>
            <p className="text-gray-300 mb-4 leading-relaxed">
              {t('footer.intro1')}
              {t('footer.intro2')}
            </p>
            <div className="flex space-x-4">
              <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                <i className="ri-wechat-fill text-white"></i>
              </div>
              <a
                href="https://wpa.qq.com/msgrd?v=3&uin=572490755&site=qq&menu=yes"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="QQ"
                className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer"
              >
                <i className="ri-qq-fill text-white"></i>
              </a>
              <a
                href="mailto:qbhy0715@qq.com"
                aria-label="Email"
                className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer"
              >
                <i className="ri-mail-fill text-white"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.quick')}</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  {t('nav.services')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('cases')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  {t('nav.cases')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('testimonials')}
                  className="text-gray-300 hover:text白 transition-colors cursor-pointer"
                >
                  {t('nav.testimonials')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('process')}
                  className="text-gray-300 hover:text白 transition-colors cursor-pointer"
                >
                  {t('nav.process')}
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.contact')}</h4>
            <ul className="space-y-3">
              <li className="flex items-center">
                <div className="w-5 h-5 flex items-center justify中心 mr-3">
                  <i className="ri-phone-fill text蓝-400"></i>
                </div>
                <a href="tel:19866724796" className="text灰-300 hover:text白">19866724796</a>
              </li>
              <li className="flex items-center">
                <div className="w-5 h-5 flex items中心 justify中心 mr-3">
                  <i className="ri-mail-fill text蓝-400"></i>
                </div>
                <a href="mailto:qbhy0715@qq.com" className="text灰-300 hover:text白">qbhy0715@qq.com</a>
              </li>
              <li className="flex items-center">
                <div className="w-5 h-5 flex items中心 justify中心 mr-3">
                  <i className="ri-map-pin-fill text蓝-400"></i>
                </div>
                <span className="text灰-300">广州市黄埔区伴河路96号自编一栋首层8097房</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2026 广州坚谷粒网络科技有限公司. 保留所有权利.
          </p>
          
        </div>
      </div>
    </footer>
  );
};

export default Footer;
